var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lawForm"},[_c('p',{staticClass:"title"},[_vm._v("法律声明")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.falv)}})])}
var staticRenderFns = []

export { render, staticRenderFns }